import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from "./notFound/pageNotFound.component";
import { UnauthorizedComponent } from './auth/components/unauthorized.component';
import { ForbiddenComponent } from './auth/components/forbidden.component';
import { MfaEnrollmentComponent } from "./auth/components/mfa/enrollment/enrollment.component";
import { MfaEnrollmentCallbackComponent } from "./auth/components/mfa/callback/callback.component";
import { AuthGuard } from "@tesla/ng-auth";
import { ShellComponent } from "./shell/shell.component";
import { ShellGuard } from "./shell/shell.guard";
import { OtpCallbackComponent } from "./shared/services/otp/otp-callback.component";
import { SessionInvalidComponent } from "./auth/components/mfa/session-invalid/session-invalid.component";

export const routes: Routes = [
  {
    path: 'otp/callback',
    component: OtpCallbackComponent,
  },
  {
    path: "",
    component: ShellComponent,
    canActivate: [AuthGuard, ShellGuard],
    runGuardsAndResolvers: "always",
    children: [
      { path: "auth/forbidden", component: ForbiddenComponent },
      { path: "auth/unauthorized", component: UnauthorizedComponent },
      { path: "auth/mfa-enrollment", component: MfaEnrollmentComponent, canActivate: [AuthGuard] },
      { path: "auth/mfa-invalid-session", component: SessionInvalidComponent, canActivate: [AuthGuard] },
      { path: "auth/mfa-enrollment/callback", component: MfaEnrollmentCallbackComponent, canActivate: [AuthGuard] },
      {
        path: "",
        canActivate: [AuthGuard],
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
        runGuardsAndResolvers: "always",
      }
    ]
  },
  { path: "**", component: PageNotFoundComponent } // if not match uri
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
